import HasPermission, { CanManageHealthPolicy } from "app/PermissionChecker";
import { NavLink } from "react-router-dom";


export default function HealthProfileChips({
    profile
}) {

    const canViewOrEditProfile = HasPermission(CanManageHealthPolicy)

    if (canViewOrEditProfile)
        return <NavLink to={"/dashboard/health/profiles"} state={{guid:profile.guid}}><button className="btn btn-secondary">{profile.name}</button></NavLink>
    else return <span>{profile.name}</span>
}

